// PC版オート、競輪共通コンポーネント
var sanrentanOddsTable = {
  template: `
    <div>
      <table class="table mb30 w100per table-vote-number" v-for="(row1, syaban1) in voteInfo.entries">
        <tr>
          <th 
            :colspan="Object.keys(voteInfo.entries).length + 1" 
            :class="'bg-lighten-' + syaban1"
          >
            <span class="pr10">{{ syaban1 }}</span>
            <span class="pr10">{{ row1.name }}</span>
            <span>（{{ row1.locker_ground || row1.pref_name }} {{ row1.graduation || row1.graduate_period + '期' }}）</span>
          </th>
        </tr>
        <tr class="text-center">
          <th :class="'bg-lighten-' + syaban1">{{ syaban1 }}</th>
          <td class="p0" v-for="(row2, syaban2) in voteInfo.entries" v-show="syaban2 !== syaban1">
            <table class="w100per">
              <tr class="text-center">
                <th :class="'bg-lighten-' + syaban2">{{ syaban2 }}</th>
                <td class="p0">
                  <table class="w100per">
                    <tr class="text-center" v-for="(col, syaban3) in voteInfo.entries" v-show="syaban3 !== syaban1 && syaban3 !== syaban2">
                      <th :class="'bg-lighten-' + syaban3">{{ syaban3 }}</th>
                      <td class="p0">
                        <a class="block" v-if="voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ]" @click.prevent="addOddsTableItems(voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ], syaban1 + '-' + syaban2 + '-' + syaban3)" :class="{'is-absent': !voteInfo.oddsTableData[syaban1 + '-' + syaban2 + '-' + syaban3].is_valid}">
                          {{ voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ].normalize_rate }}
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  `
};

export default {
  sanrentanOddsTable
}